import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MessageLogFrontService } from '../../../services/message-log/message-log.service';

@Component({
    selector: 'app-push-devices-dialog',
    templateUrl: './push-devices-dialog.component.html',
    styleUrls: ['./push-devices-dialog.component.scss'],
})
export class PushDevicesDialogComponent implements OnInit {
    loading = true;

    devices: any[] = [];
    filteredDevices: any[] = [];

    // filtros
    filter = '';
    platformFilter: '' | 'ios' | 'android' = '';

    displayedColumns = ['nombre', 'email', 'platform', 'token'];

    constructor(
        private logService: MessageLogFrontService,
        private dialogRef: MatDialogRef<PushDevicesDialogComponent>,
    ) {}

    async ngOnInit() {
        await this.loadAll();
    }

    private async loadAll() {
        this.loading = true;

        try {
            const r: any = await this.logService.getDevicesList();

            console.log('📦 RAW DEVICES RESPONSE:', r);

            const list =
                r?.response?.response?.response ??
                r?.response?.response ??
                r?.response ??
                [];

            console.log('📊 LIST FINAL:', list);

            this.devices = Array.isArray(list) ? list : [];
            this.filteredDevices = [...this.devices];

            this.applyFilter();
        } finally {
            this.loading = false;
        }
    }

    applyFilter() {
        const q = (this.filter || '').trim().toLowerCase();

        this.filteredDevices = this.devices.filter((d) => {
            const okPlatform =
                !this.platformFilter || d.pushPlatform === this.platformFilter;

            const okText =
                !q ||
                (d.nombrePersona || '').toLowerCase().includes(q) ||
                (d.apellidoPersona || '').toLowerCase().includes(q) ||
                (d.email || '').toLowerCase().includes(q);

            return okPlatform && okText;
        });
    }

    tokenPreview(token: string) {
        if (!token) return '';
        return '****' + token.slice(-6);
    }

    close() {
        this.dialogRef.close();
    }
}
